<template>
  <!-- <div class="l&#45;container"> -->
    <div class="m-menu" v-bind:class="{ 'close': close }">

      <!-- <ul> -->
      <!--   <li v&#45;for="(list, index) in filteredPins" :key="index.id">{{list.name}}</li> -->
      <!-- </ul> -->

      <ul>
        <li>
          <a @click="childOpen('add')">
            <i class="fa fa-fw fa-plus" title="登録"></i><span>登録</span>
          </a>
        </li>
        <template v-if="add">

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
            <li>
              <!-- <a class="child" href="http://153.126.169.95/users/sign_up"><i class="fa fa&#45;fw fa&#45;plus" title="User登録"></i><span>ユーザー登録</span></a><i class="fa fa&#45;fw fa&#45;plus" @click="addPin('useradd')"></i> -->
              <a class="child" href="http://153.126.169.95/users/sign_up"><i class="fa fa-fw fa-plus" title="User登録"></i><span>ユーザー登録</span></a>
            </li>
          </template>

          <li>
            <router-link class="child" to="/appointments/add"><i class="fa fa-fw fa-plus" title="AP登録"></i><span>AP登録</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/families/add"><i class="fa fa-fw fa-plus" title="家庭登録"></i><span>家庭登録</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/students/add"><i class="fa fa-fw fa-plus" title="生徒登録"></i><span>生徒登録</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/tutors/add"><i class="fa fa-fw fa-plus" title="先生登録"></i><span>先生登録</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/agreements/add"><i class="fa fa-fw fa-plus" title="契約情報登録"></i><span>契約情報登録</span></router-link>
          </li>

        </template>

        <li>
          <a @click="childOpen('list')">
            <i class="fa fa-fw fa-file-text" title="リスト"></i><span>リスト</span>
          </a>
        </li>
        <template v-if="list">

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
            <li>
              <router-link class="child" to="/users" exact><i class="fa fa-fw fa-address-card" title="Users"></i><span>ユーザーリスト</span></router-link>
            </li>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
            <li>
              <router-link class="child" to="/advisors"><i class="fa fa-fw fa-group" title="アドバイザー"></i><span>アドバイザー</span></router-link>
            </li>
          </template>

          <li>
            <router-link class="child" to="/appointments" exact><i class="fa fa-fw fa-car" title="APリスト"></i><span>APリスト</span></router-link>
          </li>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.office_id === 1 || user.office_id === 4">
            <li>
              <router-link class="child" to="/appointments2" exact><i class="fa fa-fw fa-graduation-cap" title="APリストⅡ"></i><span>APリストⅡ</span></router-link>
            </li>
          </template>

          <li>
            <router-link class="child" to="/appointments/confirms" exact><i class="fa fa-fw fa-car" title="確認リスト"></i><span>確認リスト</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/families" exact><i class="fa fa-fw fa-home" title="家庭リスト"></i><span>家庭リスト</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/students" exact><i class="fa fa-fw fa-child" title="生徒リスト"></i><span>生徒リスト</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/tutors" exact><i class="fa fa-fw fa-graduation-cap" title="先生リスト"></i><span>先生リスト</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/tutors2" exact><i class="fa fa-fw fa-graduation-cap" title="先生リストⅡ"></i><span>先生リストⅡ</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/agreements" exact><i class="fa fa-fw fa-handshake-o" title="契約リスト"></i><span>契約リスト</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/tutor_channels"><i class="fa fa-fw fa-graduation-cap" title="tutor_channels"></i><span>家庭教師登録媒体リスト</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/students/inheritance"><i class="fa fa-fw fa-graduation-cap" title="引継リスト"></i><span>引継リスト</span></router-link>
          </li>

        </template>

        <li>
          <a @click="childOpen('support')">
            <i class="fa fa-fw fa-file-text" title="対応履歴"></i><span>対応履歴</span>
          </a>
        </li>
        <template v-if="support">

          <li>
            <router-link class="child" to="/appointmentsupports"><i class="fa fa-fw fa-file-text" title="AP対応履歴"></i><span>AP対応履歴</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/familysupports"><i class="fa fa-fw fa-file-text" title="家庭対応履歴"></i><span>家庭対応履歴</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/tutorsupports"><i class="fa fa-fw fa-file-text" title="先生対応履歴"></i><span>先生対応履歴</span></router-link>
          </li>

        </template>

        <li>
          <a @click="childOpen('file')">
            <i class="fa fa-fw fa-file-pdf-o" title="PDF"></i><span>PDF</span>
          </a>
        </li>
        <template v-if="file">

          <li>
            <router-link class="child" to="/familyfiles"><i class="fa fa-fw fa-file-pdf-o" title="家庭ファイル"></i><span>家庭ファイル</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/studentfiles"><i class="fa fa-fw fa-file-pdf-o" title="生徒ファイル"></i><span>生徒ファイル</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/tutorfiles"><i class="fa fa-fw fa-file-pdf-o" title="先生ファイル"></i><span>先生ファイル</span></router-link>
          </li>

          <!-- <li> -->
          <!--   <router&#45;link class="child" to="reports"><i class="fa fa&#45;fw fa&#45;file&#45;pdf&#45;o" title="報告書"></i><span>報告書(メンテ中)</span></router&#45;link> -->
          <!-- </li> -->

        </template>

        <li>
          <a href="http://153.126.169.95/student_tutors/search?limit=30" target="_blank"><i class="fa fa-fw fa-file-pdf-o" title="報告書管理"></i><span>報告書管理</span></a>
        </li>

        <li>
          <a href="http://153.126.169.95/student_tutors/?limit=30" target="_blank"><i class="fa fa-fw fa-file-pdf-o" title="指導情報"></i><span>指導情報</span></a>
        </li>

        <template v-if="user.type === 'admin' || user.office_id === 1">
          <li>
            <a href="/kenshus"><i class="fa fa-fw fa-leanpub" title="スケジュール"></i><span>スケジュール</span></a>
          </li>
        </template>

        <template v-if="user.type === 'admin' || user.office_id === 1 || user.office_id === 3">
          <li>
            <a href="https://neo-print.masterminds.jp/" target="_blank"><i class="fa fa-fw fa-leanpub" title="AP封筒印刷"></i><span>AP封筒印刷</span></a>
          </li>
        </template>

        <li>
          <a @click="childOpen('other')">
            <i class="fa fa-fw fa-file-text" title="その他"></i><span>その他</span>
          </a>
        </li>

        <template v-if="other">

          <li>
            <router-link class="child" to="/student_tutors"><i class="fa fa-fw fa-file-text" title="探しデータ"></i><span>探しデータ</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/documents"><i class="fa fa-fw fa-book" title="documents"></i><span>documents</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/tags"><i class="fa fa-fw fa-tags" title="タグリスト"></i><span>タグリスト</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/todos"><i class="fa fa-fw fa-check-square" title="Todoリスト"></i><span>Todoリスト</span></router-link>
          </li>

          <template v-if="user.type === 'admin' || user.type === 'owner'">
            <li>
              <router-link class="child" to="/channels"><i class="fa fa-fw fa-graduation-cap" title="channels"></i><span>教師登録媒体</span></router-link>
            </li>
          </template>

          <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'mgr'">
            <li>
              <router-link class="child" to="/office_channels"><i class="fa fa-fw fa-graduation-cap" title="channels"></i><span>教師登録媒体カスタム</span></router-link>
            </li>
          </template>

          <template v-if="user.type === 'admin'">
            <li>
              <router-link class="child" to="/appointment_channels"><i class="fa fa-fw fa-exclamation-triangle" title="appointment_channels"></i><span>appointment_channels</span></router-link>
            </li>
          </template>

          <li>
            <router-link class="child" to="/versions"><i class="fa fa-fw fa-history" title="変更履歴"></i><span>変更履歴</span></router-link>
          </li>

        </template>

        <li>
          <a @click="childOpen('aggregate')">
            <i class="fa fa-fw fa-line-chart" title="集計"></i><span>集計</span>
          </a>
        </li>
        <template v-if="aggregate">

          <!-- <template v&#45;if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'mgr'"> -->
          <li>
            <router-link class="child" to="/aggregates/appointments"><i class="fa fa-fw fa-line-chart" title="集計-AP"></i><span>集計-AP</span></router-link>
          </li>
          <!-- </template> -->

          <li>
            <router-link class="child" to="/aggregates/appointments_month"><i class="fa fa-fw fa-line-chart" title="集計-月間CV"></i><span>集計-月間CV</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/aggregates/appointments_month2"><i class="fa fa-fw fa-line-chart" title="集計-月間AP"></i><span>集計-月間AP</span></router-link>
          </li>

          <li>
            <router-link class="child" to="/aggregates/tutor_channels"><i class="fa fa-fw fa-line-chart" title="集計-家庭教師"></i><span>集計-家庭教師</span></router-link>
          </li>

        </template>

        <!-- <li> -->
        <!--   <router&#45;link to="/conditions"><i class="fa fa&#45;fw fa&#45;clipboard" title="条件リスト"></i><span>条件リスト</span></router&#45;link> -->
        <!-- </li> -->
        <!-- <li> -->
        <!--   <router&#45;link to="/student_conditions"><i class="fa fa&#45;fw fa&#45;clipboard" title="生徒条件リスト"></i><span>生徒条件リスト</span></router&#45;link> -->
        <!-- </li> -->
        <!-- <li> -->
        <!--   <router&#45;link to="/tutor_conditions"><i class="fa fa&#45;fw fa&#45;clipboard" title="先生条件リスト"></i><span>先生条件リスト</span></router&#45;link> -->
        <!-- </li> -->
        <!-- <li> -->
        <!--   <router&#45;link to="/styleguide"><i class="fa fa&#45;fw fa&#45;paint&#45;brush" title="スタイルガイド"></i><span>スタイルガイド</span></router&#45;link> -->
        <!-- </li> -->

        <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting' || user.type === 'mgr' || user.id === 377">
          <li>
            <a @click="childOpen('keiri')">
              <i class="fa fa-fw fa-money" title="経理"></i><span>経理</span>
            </a>
          </li>
          <template v-if="keiri">
            <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
              <li>
                <a class="child" href="/contracts"><i class="fa fa-fw fa-money" title="台帳"></i><span>台帳</span></a>
              </li>
            </template>
          </template>
          <template v-if="keiri">
            <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
              <li>
                <router-link class="child" to="/contracts"><i class="fa fa-fw fa-money" title="契約情報"></i><span>契約情報</span></router-link>
              </li>
            </template>
          </template>
          <template v-if="keiri">
            <!-- 526.平松大 377.下田かおり 75.鈴木穣 620.穂積一郎 653.草谷勇介 627.福田匠 612.三木佑馬 520.宮崎衣未 121.嶽間澤稜来 -->
            <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting' || user.id === 526 || user.id === 377 || user.id === 75 || user.id === 620 || user.id === 653 || user.id === 627 || user.id === 612 || user.id === 520 || user.id === 121">
              <li>
                <router-link class="child" to="/paymentdetails"><i class="fa fa-fw fa-money" title="テキスト支払"></i><span>テキスト支払</span></router-link>
              </li>
            </template>
          </template>
          <template v-if="keiri">
            <!-- 526.平松大 377.下田かおり 75.鈴木穣 620.穂積一郎 653.草谷勇介 627.福田匠 612.三木佑馬 520.宮崎衣未 121.嶽間澤稜来 -->
            <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting' || user.id === 526 || user.id === 377 || user.id === 75 || user.id === 620 || user.id === 653 || user.id === 627 || user.id === 612 || user.id === 520 || user.id === 121">
              <li>
              <li>
                <router-link class="child" to="/paymentdetails2s"><i class="fa fa-fw fa-money" title="管理費支払"></i><span>管理費支払</span></router-link>
              </li>
            </template>
          </template>
          <template v-if="keiri">
            <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'accounting'">
              <li>
                <router-link class="child" to="/aggregates/contracts_month"><i class="fa fa-fw fa-line-chart" title="集計-月間売上"></i><span>集計-月間売上</span></router-link>
              </li>
            </template>
          </template>
          <template v-if="keiri">
            <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'accounting'">
              <li>
                <router-link class="child" to="/aggregates/contracts"><i class="fa fa-fw fa-line-chart" title="集計-売上"></i><span>集計-売上</span></router-link>
              </li>
            </template>
          </template>
          <template v-if="keiri">
            <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'accounting'">
              <li>
                <router-link class="child" to="/aggregates/paymentdetails"><i class="fa fa-fw fa-line-chart" title="集計-自社割賦"></i><span>集計-自社割賦</span></router-link>
              </li>
            </template>
          </template>
          <template v-if="keiri">
            <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'accounting' || user.type === 'mgr'">
              <li>
                <router-link class="child" to="/aggregates/agreements"><i class="fa fa-fw fa-line-chart" title="集計-売上-販売価格"></i><span>集計-売上-販売価格</span></router-link>
              </li>
            </template>
          </template>

        </template>

      </ul>
    </div>
  <!-- </div> -->
</template>

<script>
import moment from 'moment'

export default {
  props: ['close'],
  computed: {
    user () {
      return this.$store.getters.user
    },

    // filter
    filteredPins () {
      let self = this
      return self.pins.filter(function (pin) {
        return pin.state === true
      })
    }
  },
  data () {
    return {
      value: moment().format('YYYY/MM/DD ddd HH:mm'),
      range: false,

      // open: ''
      add: true,
      list: true,
      support: false,
      file: false,
      other: false,
      keiri: false,
      aggregate: false,

      pins: [
        { state: true, name: 'useradd', title: 'ユーザー登録' },
        { state: false, name: 'AP登録' },
        { state: true, name: '家庭登録' },
        { state: false, name: 'ユーザーリスト' }
      ]
    }
  },
  methods: {
    childOpen (col) {
      this[col] = !this[col]
    },

    addPin (col) {
      console.log('pochi')
      if (this.pins.name === col) {
        this.pins.state = !this.pins.state
      }
      // this.pins[col] = !this.pins[col]
    }
  },
  mounted () {
    let that = this
    function timer () {
      moment.lang('ja')
      that.value = moment().format('YYYY/MM/DD ddd HH:mm')
      setTimeout(timer, 1000)
    }
    setTimeout(function () {
      timer()
    }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.m-menu {
  max-height: 100vh;
  overflow-y: scroll;
  padding-bottom: 100px;
  transition: all 600ms cubic-bezier(0.86, 0, 0.07, 1);
  .date {
    margin: 0;
    padding: 10px;
    color: #adadad;
    /* color: #4a596a; */
    max-width: 220px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    transition: all .5s ease;
  }
  /* padding-top: 1rem; */
  input {
    width: 100%;
  }
  /* &__label { */
  /*   font-size: .8rem */
  /* } */
}
.m-menu::-webkit-scrollbar {
  display: none;
}
ul {
  padding: 0;
  margin:0;
  list-style-type: none;
  li {
    margin-bottom: .0em;
    white-space: nowrap;
    padding: 0 0 0 7px;
    cursor: pointer;
    transition: all .3s ease 0s;
    span {
      max-width: 220px;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      transition: all .5s ease;
    }
    a {
      /* width: 180px; */
      color: #adadad;
      /* color: #4a596a; */
      display: block;
      padding: 10px 10px;
      text-decoration: none;
      &.router-link-active {
        position: relative;
        color: #fff;
        background: #263238;
        &:before {
          content: "";
          position: absolute;
          display: block;
          width: 7px;
          height: 100%;
          top: 0;
          left: -7px;
          background: #41B883;
        }
      }
      i {
        margin-right: 5px;
      }
    }
    .child {
      transition: .5s ease 0s;
      padding-left: 25px;
    }
    &:hover {
      background: #263238;
      a {
        color: #fff;
      }
    }
  }
}
.close {
  .date {
    max-width: 0;
    display: none;
  }
  span {
    max-width: 0;
    transition: all .5s ease;
  }
  li {
    .child {
      transition: .5s ease 0s;
      padding-left: 10px;
    }
    &:hover > .help {
      opacity: 1;
    }
    .help {
      position: absolute;
      top: 50px;
      left: 100px;
      min-width: 200px;
      min-height: 50px;
      border: solid 1px #039be5;
      background: #039be5;
      color: #fff;
      padding: 3px;
      opacity: 0;
      z-index: 2;
      transition: all .5s;
      &:before {
        content: '';
        position: absolute;
        border-right: solid 5px #039be5;
        border-left: solid 5px rgba(255, 255, 255, 0);
        border-top: solid 5px rgba(255, 255, 255, 0);
        border-bottom: solid 5px rgba(255, 255, 255, 0);
        font-size: 0;
        margin: 2px 0 0 -14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Menu.vue?7a63f264